import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { handleImgError } from '../utils/imageErrorHandler';

const PreviewWrap = styled.div`
  position: relative;
  padding: 16px 24px;

  img {
    height: 100%;
    width: 100%;
    max-width: 380px;
    max-height: 374px;
    object-fit: contain;
  }
`;

const Preview = ({ sessionId, videoWidth }) => {
  const [isVideo, setIsVideo] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/${sessionId}/video.mp4`, {
      mode: 'cors',
    }).then((res) => {
      if (res.ok) {
        setIsVideo(true);
      }
    });
  }, [sessionId]);

  return (
    <PreviewWrap>
      {isVideo ? (
        <video playsInline autoPlay loop muted width={videoWidth || 320}>
          <source
            src={`${process.env.REACT_APP_BASE_URL}/${sessionId}/video.mp4`}
            type="video/mp4"
          />
          <track kind="captions" />
        </video>
      ) : (
        <img
          src={`${process.env.REACT_APP_BASE_URL}/${sessionId}/image.jpg`}
          alt="img-preview"
          onError={handleImgError}
        />
      )}
    </PreviewWrap>
  );
};

export default Preview;
